export const sx = {
    image: {
        width: '80px',
        height: '80px',
        objectFit: 'contain',
        margin: '15px auto 5px',

    },
    menuBar: {
        button: {
            width: '100%'
        }
    },
    name:{
        textAlign:'center',
        padding:'5px 3px',
    }
}